var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-anonymous-default-export */
import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_ERROR, CURRENT_AUTHENTICATED_USER, CURRENT_AUTHENTICATED_USER_SUCCESS, CURRENT_AUTHENTICATED_USER_ERROR, FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR, NEW_PASSWORD, NEW_PASSWORD_SUCCESS, NEW_PASSWORD_ERROR, COMPLETE_NEW_PASSWORD, COMPLETE_NEW_PASSWORD_SUCCESS, COMPLETE_NEW_PASSWORD_ERROR, LOGOUT_USER, LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD, } from '../actions';
var LOGIN_STATE = {
    loading: false,
    error: '',
};
var FORGOT_PASSWORD_STATE = {
    email: '',
    loading: false,
    error: '',
};
var NEW_PASSWORD_STATE = {
    loading: false,
    error: '',
};
var INIT_STATE = {
    auth: false,
    token: null,
    user: null,
    login: LOGIN_STATE,
    forgotPassword: FORGOT_PASSWORD_STATE,
    newPassword: NEW_PASSWORD_STATE,
    // newPassword: '',
    // resetPasswordCode: '',
    // isResetPassword: false,
    // isCompleteNewPassword: false,
    loading: true,
    error: '',
};
export default (function (state, action) {
    if (state === void 0) { state = INIT_STATE; }
    switch (action.type) {
        case LOGIN_USER:
            return __assign(__assign({}, state), { login: { loading: true, error: '' } });
        case LOGIN_USER_WITH_COMPLETE_NEW_PASSWORD:
            return __assign(__assign({}, state), { user: action.payload });
        case LOGIN_USER_SUCCESS:
            return __assign(__assign({}, state), { auth: true, login: LOGIN_STATE });
        case LOGIN_USER_ERROR:
            return __assign(__assign({}, state), { login: {
                    loading: false,
                    error: action.payload.message,
                } });
        case CURRENT_AUTHENTICATED_USER:
            return __assign(__assign({}, state), { loading: true, error: '' });
        case CURRENT_AUTHENTICATED_USER_SUCCESS:
            var token = action.payload.token;
            return __assign(__assign({}, state), { auth: true, token: token, loading: false, error: '' });
        case CURRENT_AUTHENTICATED_USER_ERROR:
            return __assign(__assign({}, state), { auth: false, loading: false, error: '' });
        case FORGOT_PASSWORD:
            var email = action.payload.email;
            return __assign(__assign({}, state), { forgotPassword: {
                    email: email,
                    loading: true,
                    error: '',
                } });
        case FORGOT_PASSWORD_SUCCESS:
            return __assign(__assign({}, state), { forgotPassword: __assign(__assign({}, state.forgotPassword), { loading: false, error: '' }) });
        case FORGOT_PASSWORD_ERROR:
            return __assign(__assign({}, state), { forgotPassword: {
                    email: '',
                    loading: false,
                    error: action.payload.message,
                } });
        case NEW_PASSWORD:
            return __assign(__assign({}, state), { newPassword: {
                    loading: true,
                    error: '',
                } });
        case NEW_PASSWORD_SUCCESS:
            return __assign(__assign({}, state), { forgotPassword: __assign(__assign({}, state.forgotPassword), { email: '' }), newPassword: {
                    loading: false,
                    error: '',
                } });
        case NEW_PASSWORD_ERROR:
            return __assign(__assign({}, state), { forgotPassword: __assign(__assign({}, state.forgotPassword), { email: '' }), newPassword: {
                    loading: false,
                    error: action.payload.message,
                } });
        case COMPLETE_NEW_PASSWORD:
            return __assign(__assign({}, state), { loading: true, error: '' });
        case COMPLETE_NEW_PASSWORD_SUCCESS:
            return __assign(__assign({}, state), { auth: true, loading: false, error: '' });
        case COMPLETE_NEW_PASSWORD_ERROR:
            return __assign(__assign({}, state), { loading: false, error: action.payload.message });
        case LOGOUT_USER:
            return __assign(__assign({}, state), { auth: false, user: null, error: '', login: {
                    error: action.payload.loginMessage,
                } });
        default:
            return __assign({}, state);
    }
});
